// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReSharper disable once CssBrowserCompatibility */

:root {
    --dark-color-primary: #188BDE;
    --dark-color-secondary: #6c757d;
    --dark-color-tertiary: #6f42c1;
    --dark-color-info: #0dcaf0;
    --dark-color-success: #198754;
    --dark-color-warning: #ffc107;
    --dark-color-error: #dc3545;
    --dark-color-body-text: #ffffff;
    --dark-color-body-bg: #222222;
    --dark-color-headings-text: #ffffff;
    --dark-color-subtle-text: #cccccc;
    --dark-color-disabled-text: #aaaaaa;
    --dark-color-component-text: #ffffff;
    --dark-color-component-bg: #333333;
    --dark-color-base-text: #ffffff;
    --dark-color-base-bg: #212529;
    --dark-color-hovered-text: #ffffff;
    --dark-color-hovered-bg: #343a40;
    --dark-color-selected-text: #ffffff;
    --dark-color-selected-bg: #0d6efd;
    --dark-color-kendo-button-text: #ffffff;
    --dark-color-kendo-button-bg: #343a40;
    --dark-color-link-text: #188BDE;
    --dark-color-link-hover-text: #0a58ca;
    --dark-color-border: #495057;
    --dark-color-border: rgba(255,255,255,0.13);
    --dark-color-series-a: #0d6efd;
    --dark-color-series-b: #6f42c1;
    --dark-color-series-c: #20c997;
    --dark-color-series-d: #198754;
    --dark-color-series-e: #ffc107;
    --dark-color-series-f: #dc3545;
}

html { scrollbar-color: #61605f var(--dark-color-component-bg); }

::-webkit-scrollbar { background-color: var(--dark-color-component-bg); }

::-webkit-scrollbar-thumb { background-color: #61605f; }

body {
    background: var(--dark-color-body-bg);
    color: var(--dark-color-body-text);
}

a { color: var(--dark-color-link-text) }

h1 { color: var(--dark-color-headings-text); }

h2 { color: var(--dark-color-subtle-text); }

.k-dropdown-button.dm-positive .k-button {
    background: var(--dark-color-success);
    border-color: var(--dark-color-success);
    color: #fff;
}

.k-dropdown-button.dm-positive .k-button .k-icon { color: #fff; }

.k-button.dm-positive-filled {
    background: var(--dark-color-success);
    border-color: var(--dark-color-success);
    color: #fff;
}

.k-button.dm-positive-filled .k-icon { color: #fff; }

.k-button.dm-negative-filled {
    background: var(--dark-color-error);
    border-color: var(--dark-color-error);
    color: #fff;
}

.k-button.dm-negative-filled .k-icon { color: #fff; }

.k-grid td.dm-link-cell .dm-i { color: #A5B5C7; }

.k-grid td.dm-link-cell .k-icon-button {
    background: transparent;
    color: #A5B5C7;
}

.k-grid td.dm-link-cell a { color: #A5B5C7; }

.k-grid td.dm-link-cell a:hover, .k-grid td.dm-link-cell .k-icon-button:hover { color: #4F7CB8 !important; }

.k-master-row > .k-grid-content-sticky {
    box-shadow: -4px 0 0 -1px rgba(200, 200, 200, 0.1);
}

.k-panelbar .k-content { background: var(--dark-color-base-bg); }

.k-dropdowntree .k-dropdown-wrap { color: #9EB6C8; }

::placeholder { color: #6e646a !important; }

:-ms-input-placeholder { color: #6e646a !important; }

::-ms-input-placeholder { color: #6e646a !important; }

.k-list-ul .k-list-item:hover, .k-list .k-list-item.k-state-hover, .k-list-optionlabel:hover, .k-list-optionlabel.k-state-hover {
    background-color: #CDEAF3;
    color: #9EB6C8;
}

.k-list-filter > .k-searchbox { border-color: #525880; }

.k-toolbar { background-color: var(--dark-color-component-bg); }

.k-drawer {
    background-color: var(--dark-color-component-bg);
    border-color: #293037;
    box-shadow: inset -1px 0 0 #1a2631;
}

.k-drawer-item.k-state-selected {
    background-color: #CDEAF3;
    color: #333333;
}

.dm-drawer {
    background-color: var(--dark-color-component-bg) !important;
    border-color: #2B3B45;
    color: #a0a8bc;
}

.dm-drawer-item:hover {
    background-color: #2E3A59 !important;
    color: #ffffff;
}

.dm-drawer-item.k-state-selected {
    background-color: #CDEAF3;
    color: #333333;
}

.dm-toolbar {
    border-bottom: 1px inset #141D25;
}

.dm-menu-selected {
    background-color: var(--dark-color-primary) !important;
    color: var(--dark-color-body-text) !important;
}

div.dm-login-back { background-color: #000000; }

.dm-field-updated { color: var(--dark-color-primary) !important; }
.dm-field-main { color: var(--dark-color-warning) !important; }

.dm-card-inline-dialog {
    background: #1A2631;
    border: 1px solid #2B3B45;
}

.dm-label {
    color: #A0A5A8;
}

.dm-label-nowrap {
    color: #A0A5A8;
}

.dm-bordered-buttom { border-bottom: 1px solid #2B3B45; }

.dm-export-start { background: #444444; }`, "",{"version":3,"sources":["webpack://./ClientApp/styles/dark/override.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,8BAA8B;IAC9B,0BAA0B;IAC1B,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;IAC3B,+BAA+B;IAC/B,6BAA6B;IAC7B,mCAAmC;IACnC,iCAAiC;IACjC,mCAAmC;IACnC,oCAAoC;IACpC,kCAAkC;IAClC,+BAA+B;IAC/B,6BAA6B;IAC7B,kCAAkC;IAClC,gCAAgC;IAChC,mCAAmC;IACnC,iCAAiC;IACjC,uCAAuC;IACvC,qCAAqC;IACrC,+BAA+B;IAC/B,qCAAqC;IACrC,4BAA4B;IAC5B,2CAA2C;IAC3C,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA,OAAO,uDAAuD,EAAE;;AAEhE,sBAAsB,gDAAgD,EAAE;;AAExE,4BAA4B,yBAAyB,EAAE;;AAEvD;IACI,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA,IAAI,mCAAmC;;AAEvC,KAAK,sCAAsC,EAAE;;AAE7C,KAAK,oCAAoC,EAAE;;AAE3C;IACI,qCAAqC;IACrC,uCAAuC;IACvC,WAAW;AACf;;AAEA,mDAAmD,WAAW,EAAE;;AAEhE;IACI,qCAAqC;IACrC,uCAAuC;IACvC,WAAW;AACf;;AAEA,uCAAuC,WAAW,EAAE;;AAEpD;IACI,mCAAmC;IACnC,qCAAqC;IACrC,WAAW;AACf;;AAEA,uCAAuC,WAAW,EAAE;;AAEpD,gCAAgC,cAAc,EAAE;;AAEhD;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA,4BAA4B,cAAc,EAAE;;AAE5C,gFAAgF,yBAAyB,EAAE;;AAE3G;IACI,kDAAkD;AACtD;;AAEA,yBAAyB,qCAAqC,EAAE;;AAEhE,mCAAmC,cAAc,EAAE;;AAEnD,gBAAgB,yBAAyB,EAAE;;AAE3C,yBAAyB,yBAAyB,EAAE;;AAEpD,0BAA0B,yBAAyB,EAAE;;AAErD;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,gCAAgC,qBAAqB,EAAE;;AAEvD,aAAa,gDAAgD,EAAE;;AAE/D;IACI,gDAAgD;IAChD,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2DAA2D;IAC3D,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sDAAsD;IACtD,6CAA6C;AACjD;;AAEA,oBAAoB,yBAAyB,EAAE;;AAE/C,oBAAoB,2CAA2C,EAAE;AACjE,iBAAiB,2CAA2C,EAAE;;AAE9D;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB,gCAAgC,EAAE;;AAExD,mBAAmB,mBAAmB,EAAE","sourcesContent":["/* ReSharper disable once CssBrowserCompatibility */\r\n\r\n:root {\r\n    --dark-color-primary: #188BDE;\r\n    --dark-color-secondary: #6c757d;\r\n    --dark-color-tertiary: #6f42c1;\r\n    --dark-color-info: #0dcaf0;\r\n    --dark-color-success: #198754;\r\n    --dark-color-warning: #ffc107;\r\n    --dark-color-error: #dc3545;\r\n    --dark-color-body-text: #ffffff;\r\n    --dark-color-body-bg: #222222;\r\n    --dark-color-headings-text: #ffffff;\r\n    --dark-color-subtle-text: #cccccc;\r\n    --dark-color-disabled-text: #aaaaaa;\r\n    --dark-color-component-text: #ffffff;\r\n    --dark-color-component-bg: #333333;\r\n    --dark-color-base-text: #ffffff;\r\n    --dark-color-base-bg: #212529;\r\n    --dark-color-hovered-text: #ffffff;\r\n    --dark-color-hovered-bg: #343a40;\r\n    --dark-color-selected-text: #ffffff;\r\n    --dark-color-selected-bg: #0d6efd;\r\n    --dark-color-kendo-button-text: #ffffff;\r\n    --dark-color-kendo-button-bg: #343a40;\r\n    --dark-color-link-text: #188BDE;\r\n    --dark-color-link-hover-text: #0a58ca;\r\n    --dark-color-border: #495057;\r\n    --dark-color-border: rgba(255,255,255,0.13);\r\n    --dark-color-series-a: #0d6efd;\r\n    --dark-color-series-b: #6f42c1;\r\n    --dark-color-series-c: #20c997;\r\n    --dark-color-series-d: #198754;\r\n    --dark-color-series-e: #ffc107;\r\n    --dark-color-series-f: #dc3545;\r\n}\r\n\r\nhtml { scrollbar-color: #61605f var(--dark-color-component-bg); }\r\n\r\n::-webkit-scrollbar { background-color: var(--dark-color-component-bg); }\r\n\r\n::-webkit-scrollbar-thumb { background-color: #61605f; }\r\n\r\nbody {\r\n    background: var(--dark-color-body-bg);\r\n    color: var(--dark-color-body-text);\r\n}\r\n\r\na { color: var(--dark-color-link-text) }\r\n\r\nh1 { color: var(--dark-color-headings-text); }\r\n\r\nh2 { color: var(--dark-color-subtle-text); }\r\n\r\n.k-dropdown-button.dm-positive .k-button {\r\n    background: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    color: #fff;\r\n}\r\n\r\n.k-dropdown-button.dm-positive .k-button .k-icon { color: #fff; }\r\n\r\n.k-button.dm-positive-filled {\r\n    background: var(--dark-color-success);\r\n    border-color: var(--dark-color-success);\r\n    color: #fff;\r\n}\r\n\r\n.k-button.dm-positive-filled .k-icon { color: #fff; }\r\n\r\n.k-button.dm-negative-filled {\r\n    background: var(--dark-color-error);\r\n    border-color: var(--dark-color-error);\r\n    color: #fff;\r\n}\r\n\r\n.k-button.dm-negative-filled .k-icon { color: #fff; }\r\n\r\n.k-grid td.dm-link-cell .dm-i { color: #A5B5C7; }\r\n\r\n.k-grid td.dm-link-cell .k-icon-button {\r\n    background: transparent;\r\n    color: #A5B5C7;\r\n}\r\n\r\n.k-grid td.dm-link-cell a { color: #A5B5C7; }\r\n\r\n.k-grid td.dm-link-cell a:hover, .k-grid td.dm-link-cell .k-icon-button:hover { color: #4F7CB8 !important; }\r\n\r\n.k-master-row > .k-grid-content-sticky {\r\n    box-shadow: -4px 0 0 -1px rgba(200, 200, 200, 0.1);\r\n}\r\n\r\n.k-panelbar .k-content { background: var(--dark-color-base-bg); }\r\n\r\n.k-dropdowntree .k-dropdown-wrap { color: #9EB6C8; }\r\n\r\n::placeholder { color: #6e646a !important; }\r\n\r\n:-ms-input-placeholder { color: #6e646a !important; }\r\n\r\n::-ms-input-placeholder { color: #6e646a !important; }\r\n\r\n.k-list-ul .k-list-item:hover, .k-list .k-list-item.k-state-hover, .k-list-optionlabel:hover, .k-list-optionlabel.k-state-hover {\r\n    background-color: #CDEAF3;\r\n    color: #9EB6C8;\r\n}\r\n\r\n.k-list-filter > .k-searchbox { border-color: #525880; }\r\n\r\n.k-toolbar { background-color: var(--dark-color-component-bg); }\r\n\r\n.k-drawer {\r\n    background-color: var(--dark-color-component-bg);\r\n    border-color: #293037;\r\n    box-shadow: inset -1px 0 0 #1a2631;\r\n}\r\n\r\n.k-drawer-item.k-state-selected {\r\n    background-color: #CDEAF3;\r\n    color: #333333;\r\n}\r\n\r\n.dm-drawer {\r\n    background-color: var(--dark-color-component-bg) !important;\r\n    border-color: #2B3B45;\r\n    color: #a0a8bc;\r\n}\r\n\r\n.dm-drawer-item:hover {\r\n    background-color: #2E3A59 !important;\r\n    color: #ffffff;\r\n}\r\n\r\n.dm-drawer-item.k-state-selected {\r\n    background-color: #CDEAF3;\r\n    color: #333333;\r\n}\r\n\r\n.dm-toolbar {\r\n    border-bottom: 1px inset #141D25;\r\n}\r\n\r\n.dm-menu-selected {\r\n    background-color: var(--dark-color-primary) !important;\r\n    color: var(--dark-color-body-text) !important;\r\n}\r\n\r\ndiv.dm-login-back { background-color: #000000; }\r\n\r\n.dm-field-updated { color: var(--dark-color-primary) !important; }\r\n.dm-field-main { color: var(--dark-color-warning) !important; }\r\n\r\n.dm-card-inline-dialog {\r\n    background: #1A2631;\r\n    border: 1px solid #2B3B45;\r\n}\r\n\r\n.dm-label {\r\n    color: #A0A5A8;\r\n}\r\n\r\n.dm-label-nowrap {\r\n    color: #A0A5A8;\r\n}\r\n\r\n.dm-bordered-buttom { border-bottom: 1px solid #2B3B45; }\r\n\r\n.dm-export-start { background: #444444; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
